import api from '../utils/api';

// Fetch all notifications
export const getAllNotifications = async (headers) => {
  try {
    const response = await api.get('/api/notifications',  headers );
    return response.data;
  } catch (error) {
    console.error('Error fetching all notifications:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Fetch a specific notification by ID
export const getNotificationById = async (id, headers) => {
  try {
    const response = await api.get(`/api/notifications/${id}`,  headers );
    return response.data;
  } catch (error) {
    console.error(`Error fetching notification with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};

// Create a new notification
export const createNotification = async (notificationData, headers) => {
  try {
    const response = await api.post('/api/notifications', notificationData,  headers );
    return response.data;
  } catch (error) {
    console.error('Error creating notification:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Update an existing notification
export const updateNotification = async (id, notificationData, headers) => {
  try {
    const response = await api.put(`/api/notifications/${id}`, notificationData,  headers );
    return response.data;
  } catch (error) {
    console.error(`Error updating notification with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};

// Delete a notification
export const deleteNotification = async (id, headers) => {
  try {
    const response = await api.delete(`/api/notifications/${id}`,  headers );
    return response.data;
  } catch (error) {
    console.error(`Error deleting notification with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};

// Fetch notifications by user ID, role, and email
export const getNotificationsByUserId = async (id, userType, email, headers) => {
  try {
    const response = await api.get(`/api/notifications/${id}/${userType}/${email}`,  headers );
    console.log("getNotificationsByUserId", response.data)
    return response.data;
  } catch (error) {
    console.error('Error fetching notifications by user ID:', error.message);
    if (error.response) {
      console.error('Response data:', error.response.data);
      console.error('Response status:', error.response.status);
      console.error('Response headers:', error.response.headers);
    }
    throw error;
  }
};

// Mark notification as read
export const markNotificationAsRead = async (id, email, headers) => {
  try {
    console.log(`Marking notification as read for ID: ${id} and email: ${email}`);
    const response = await api.put(`/api/notifications/read/${id}`, { email },  headers );
    console.log('Mark notification as read response:', response.data);
    return response.data;
  } catch (error) {
    console.error(`Error marking notification as read with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};
